import ReceiptVoucher from "./ReceiptVoucher";
import PaymentVoucher from "./PaymentVoucher";
import JournalVoucher from "./JournalVoucher";
import ShowVoucher from "./ShowVoucher";

export default { ReceiptVoucher, PaymentVoucher, JournalVoucher, ShowVoucher };
